module.exports = __webpack_public_path__ + "img/contract.a4d29e06.svg";